import React from 'react'
import { useMemo, useState } from 'react'
import { filesize } from 'filesize'


export const useMediaExpandedModalService = (props) => {
  const { expandedImage } = props

  const [currentTab, setCurrentTab] = useState(0)


  // Use new structure: {groupId, feedFile, reelFile}
  const feedFile = expandedImage.feedFile || null
  const reelFile = expandedImage.reelFile || null
  const hasFeed = !!feedFile
  const hasReel = !!reelFile
    
  // Create tabs data - always show tabs
  const tabsData = useMemo(() => {
    const renderTab = (file) => {
      if (!file) return null
      return (
        <div>
          <div className="media-uploads_preview_image">
            {file.type?.startsWith('video') ? (
              <video controls src={file.url} title={file.name} />
            ) : (
              <img src={file.preview || file.url} alt={file.name} />
            )}
          </div>
          
          <div className="media-uploads_preview_header">
            <p>{file.filename ?? file.name}</p>
            <p>{filesize(file.size || 0)}</p>
          </div>
        </div>
      )
    }

    return [
      {
        title: 'Feed',
        disableTab: !hasFeed,
        component: renderTab(feedFile),
        file: feedFile,
      },
      {
        title: 'Reel',
        disableTab: !hasReel,
        component: renderTab(reelFile),
        file: reelFile,
      },
    ]
  }, [hasFeed, hasReel, feedFile, reelFile])

  // Reset tab when switching between items
  React.useEffect(() => {
    // Set initial tab to feed if available, otherwise reel
    if (hasFeed) {
      setCurrentTab(0)
    } else if (hasReel) {
      setCurrentTab(1)
    }
  }, [expandedImage?.id, hasFeed, hasReel])

  // return
  return {
    tabsData,
    currentTab,
    setCurrentTab,
  }
}